

export default {

    setCredentials : (key_name, token_hash) => {
        // document.cookie=`${key_name}=${token_hash}`;
        localStorage.setItem(key_name, token_hash);
    },

    getCredentials: (name) => {
        let val = ''

        // const value = `; ${document.cookie}`;
        // const parts = value.split(`; ${name}=`);
        // if (parts.length === 2) {
        //     // return parts.pop().split(';').shift();
        //     return parts.split(';').shift();
        // }

        // return document.cookie.get(`${name}`)

        // var cookieArr = document.cookie.split(";");
        // // Loop through the array elements
        // for(var i = 0; i < cookieArr.length; i++) {
        //     var cookiePair = cookieArr[i].split("=");
            
        //     /* Removing whitespace at the beginning of the cookie name
        //     and compare it with the given string */
        //     if(name == cookiePair[0].trim()) {
        //         // Decode the cookie value and return
        //         return decodeURIComponent(cookiePair[1]);
        //     }
        // }
        // // Return null if not found
        // return null;

        // const matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
        // return matches ? decodeURIComponent(matches[1]) : undefined;

        val = localStorage.getItem(name);

        return val
    },

    deleteCredentials: (name) => {
        // document.cookie = name +'=;';
        localStorage.clear();
    },

}